module.exports = __webpack_public_path__ + "media/images/badges/akt-badge-d3482320efa59ecafefc910119ca3ddf.svg";